export default "__VITE_ASSET__a5b16f48__"